import { t } from 'i18next';
import { WeekDays } from 'models/general';
import moment from 'moment-timezone';

export const humanizeSeconds = (secondsInput?: number): string => {
  if (!secondsInput) {
    return '--';
  }

  const duration = moment.duration({ seconds: secondsInput });
  const seconds = duration.seconds();
  const minutes = duration.minutes();
  const hours = duration.hours();
  let output = '';

  if (hours) {
    output += `${hours}${t('common.reductions.h')}`;
  }

  if (minutes) {
    if (output) {
      output += ' ';
    }

    output += `${minutes}${t('common.reductions.m')}`;
  }

  if (seconds) {
    output += ' ' + `${seconds}${t('common.reductions.s')}`;
  } else if (!output) {
    output += `${seconds}${t('common.reductions.s')}`;
  }

  return output;
};

export function humanizeSecondsWithoutDays(secondsInput?: number): string {
  if (!secondsInput) {
    return '--';
  }

  const minutes = Math.floor(secondsInput / 60);
  const hours = Math.floor(minutes / 60);

  return hours > 0
    ? `${hours}${t('common.reductions.h')} ${minutes % 60}${t('common.reductions.m')}`
    : `${minutes % 60}${t('common.reductions.m')}`;
}

export type TimeRange = { from: string; to: string };

export const fullDayTimeRange: TimeRange = { from: '00:00', to: '23:59' } as const;

/**
 *
 * @param from date to start checking for weekdays
 * @param to date to provide availabile weekends up to it
 * @param options
 *  allWeekdaysOnMissingValue: if no from or to wether to provide all available weekdays or nothing
 * @returns
 */
export const getWeekdays = (
  from?: moment.Moment | null,
  to?: moment.Moment | null,
  options?: { allWeekdaysOnMissingValue?: boolean },
): WeekDays[] => {
  if (!from || !to) {
    return options?.allWeekdaysOnMissingValue ? (Array.from({ length: 7 }, (_, index: number) => index) as WeekDays[]) : [];
  }

  const start = from.clone().local(false);
  const end = to.clone().local(false);

  const weekdays: WeekDays[] = [];

  while (start.isSameOrBefore(end) && weekdays.length <= 6) {
    const weekday = start.get('weekday') === 6 ? 0 : ((start.get('weekday') + 1) as WeekDays);

    if (!weekdays.includes(weekday)) {
      weekdays.push(weekday);
    }

    start.add(1, 'days');
  }

  return weekdays;
};

export const timeStringToObject = (time: string | null, key: string): { [key: string]: { hour: number; minute: number } } => {
  if (!time) {
    return {};
  }

  const [hour, minute] = time.split(':').map((value) => Number(value));

  return {
    [key]: {
      hour,
      minute,
    },
  };
};
